module.exports = __webpack_public_path__ + "static/placeholder-01@2x-67dff7ba44289dc91e44022ff3455154.png";